import { Outlet, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function SiteLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className={`flex-1 w-full ${isHome ? '' : 'pt-16 md:pt-20'}`}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}